import styled from 'styled-components';
import React from 'react';

const Container = styled.div`
  border: 1px solid #eee;
`;
const Toolbar = styled.div`
  border-bottom: 1px solid #eee;
  padding: 5px 10px;
  text-align: center;
  > code {
    font-weight: bold;
  }
`;
const Content = styled.div`
  padding: 5px 10px;
  height: 500px;
  overflow: scroll;
`;

class ViewContainer extends React.Component {
  render() {
    const { children, className } = this.props;
    return (
      <Container className={className}>
        <Toolbar>
          <code>미리보기</code>
        </Toolbar>
        <Content>{children}</Content>
      </Container>
    );
  }
}

export default ViewContainer;
